module.exports = __webpack_public_path__ + "img/logo-white-icon.3704162.png";